<template>
  <svg
    width="362"
    height="191"
    viewBox="0 0 362 191"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2751_1667)">
      <path
        opacity="0.96"
        d="M332.194 16.2077C332.194 16.2077 331.584 11.6254 329.546 8.5972C327.508 5.56994 326.102 2.08948 328.703 0.965309C331.303 -0.158862 332.523 9.00667 332.195 16.2077H332.194Z"
        fill="#ACE3E0"
      />
      <path
        d="M56.164 173.168C56.164 170.735 54.2548 168.764 51.8998 168.764C49.5448 168.764 47.6357 170.735 47.6357 173.168V178.744C47.6357 181.176 49.5448 183.147 51.8998 183.147C54.2548 183.147 56.164 181.176 56.164 178.744V173.168Z"
        fill="#ACE3E0"
      />
      <path
        d="M271.639 173.168C271.639 170.735 269.729 168.764 267.374 168.764C265.019 168.764 263.11 170.735 263.11 173.168V178.744C263.11 181.176 265.019 183.147 267.374 183.147C269.729 183.147 271.639 181.176 271.639 178.744V173.168Z"
        fill="#ACE3E0"
      />
      <path
        d="M8.1582 97.4945C8.1582 97.4945 17.547 136.158 24.3558 152.78C31.1646 169.401 33.7956 178.67 70.9336 172.916C108.073 167.162 118.905 166.589 176.779 174.626C234.654 182.665 276.281 183.463 295.625 164.764C314.969 146.066 326.264 87.3945 326.264 87.3945L8.1582 97.4945Z"
        fill="#E4E4E4"
      />
      <mask
        id="mask0_2751_1667"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="8"
        y="87"
        width="319"
        height="94"
      >
        <path
          d="M8.1582 97.4945C8.1582 97.4945 17.547 136.158 24.3558 152.78C31.1646 169.401 33.7956 178.67 70.9336 172.916C108.073 167.162 118.905 166.589 176.779 174.626C234.654 182.665 276.281 183.463 295.625 164.764C314.969 146.066 326.264 87.3945 326.264 87.3945L8.1582 97.4945Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2751_1667)">
        <path
          opacity="0.27"
          d="M7.64182 128.385C7.64182 128.385 7.31449 160.669 55.1999 161.307C103.083 161.945 127.621 146.604 177.139 160.03C226.658 173.454 299.348 172.587 318.867 145.822C309.911 200.942 231.61 220.76 229.444 219.16C227.277 217.563 83.4154 207.203 83.4154 207.203C83.4154 207.203 2.86208 210.531 1.33101 201.262C-0.200051 191.992 7.64182 128.385 7.64182 128.385Z"
          fill="#4D4D4D"
        />
      </g>
      <path
        d="M2.17516 75.3234C-5.00149 93.4295 7.74682 106.008 34.1568 111.123C60.5668 116.237 120.401 123.482 174.666 121.777C228.931 120.072 286.886 111.257 319.959 93.6494C353.034 76.0413 331.062 53.1625 317.238 46.5558C303.415 39.9492 280.099 37.8191 258.021 39.3112C235.944 40.8034 190.964 48.2607 151.97 59.1294C112.973 69.9963 84.2948 53.8023 50.8683 54.8673C17.4436 55.9324 5.15105 67.8135 2.17516 75.3234Z"
        fill="#4D4D4D"
      />
      <path
        d="M10.7366 71.275C1.86168 81.662 7.48614 93.1705 22.6525 98.4431C37.8171 103.718 86.0984 109.95 121.072 112.027C156.045 114.105 193.803 114.425 245.178 105.155C296.553 95.8859 329.825 83.5795 326.264 67.918C322.706 52.2565 309.396 46.9821 293.028 44.7084C276.66 42.4347 256.061 43.2526 237.181 46.3423C218.301 49.4321 197.669 52.5219 179.615 56.8893C161.561 61.2568 144.23 67.9707 129.271 67.8635C114.312 67.7563 96.0521 64.7737 80.0621 61.3641C68.9205 58.8068 47.9784 57.3146 33.7413 60.1918C19.7452 63.0198 15.3773 65.8388 10.7348 71.2731L10.7366 71.275Z"
        fill="#E4E4E4"
      />
      <mask
        id="mask1_2751_1667"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="6"
        y="43"
        width="321"
        height="71"
      >
        <path
          d="M10.7366 71.275C1.86168 81.662 7.48614 93.1705 22.6525 98.4431C37.8171 103.718 86.0984 109.95 121.072 112.027C156.045 114.105 193.803 114.425 245.178 105.155C296.553 95.8859 329.825 83.5795 326.264 67.918C322.706 52.2565 309.396 46.9821 293.028 44.7084C276.66 42.4347 256.061 43.2526 237.181 46.3423C218.301 49.4321 197.669 52.5219 179.615 56.8893C161.561 61.2568 144.23 67.9707 129.271 67.8635C114.312 67.7563 96.0521 64.7737 80.0621 61.3641C68.9205 58.8068 47.9784 57.3146 33.7413 60.1918C19.7452 63.0198 15.3773 65.8388 10.7348 71.2731L10.7366 71.275Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_2751_1667)">
        <path
          d="M11.8721 107.713C12.6974 106.22 9.73914 83.8468 47.6356 84.0595C85.5304 84.2721 99.5616 96.2495 141.652 91.3277C183.742 86.404 186.632 78.5197 229.135 74.045C271.639 69.5702 313.937 70.8934 315.586 91.3277C317.237 111.762 240.069 152.674 239.452 152.674C238.834 152.674 92.744 139.176 75.9322 137.934C59.1204 136.693 11.8721 107.713 11.8721 107.713Z"
          fill="#ACE3E0"
        />
      </g>
      <path d="M335.553 33.248H330.594V67.3294H335.553V33.248Z" fill="#4D4D4D" />
      <path
        opacity="0.96"
        d="M331.317 33.1591C326.4 32.5999 324.063 25.7262 323.983 20.3008C323.902 14.8744 327.852 13.6874 329.624 16.231C331.397 18.7745 333.332 17.7573 333.736 14.3662C334.139 10.9752 333.977 7.07508 338.007 3.42951C342.037 -0.216068 351.387 -0.810005 348.082 7.32963C344.777 15.4683 340.102 19.3337 341.553 22.9542C343.004 26.5747 340.022 34.1493 331.317 33.1601V33.1591Z"
        fill="#ACE3E0"
      />
    </g>
    <defs>
      <clipPath id="clip0_2751_1667">
        <rect width="362" height="189.151" fill="white" transform="translate(0 0.871094)" />
      </clipPath>
    </defs>
  </svg>
</template>
